import { authRoles } from "../../../auth/authRoles";
import Data from "./Data/Data";
import EditData from "./Data/EditData";
import TambahData from "./Data/TambahData";
import EditTipe from "./Tipe/EditTipe";
import TambahTipe from "./Tipe/TambahTipe";
import Tipe from "./Tipe/Tipe";

const propertyDevRoutes = [
  {
    path: "/tipe_property/edit/:id",
    exact: true,
    component: EditTipe,
    auth: authRoles.all,
  },
  {
    path: "/tipe_property/tambah",
    exact: true,
    component: TambahTipe,
    auth: authRoles.all,
  },
  {
    path: "/tipe_property",
    exact: true,
    component: Tipe,
    auth: authRoles.all,
  },
  {
    path: "/data_property/edit/:id",
    exact: true,
    component: EditData,
    auth: authRoles.all,
  },
  {
    path: "/data_property/tambah",
    exact: true,
    component: TambahData,
    auth: authRoles.all,
  },
  {
    path: "/data_property",
    exact: true,
    component: Data,
    auth: authRoles.all,
  },
];

export default propertyDevRoutes;
